export function postData(
  url: string,
  data: FormData,
  callback: (responseData: any, status_code: number) => void
) {
  fetch(url, {
    method: "POST",
    body: data,
  }).then((response) =>
    response.json().then((json) => callback(json, response.status))
  );
}

export function updateData(
  url: string,
  data: URLSearchParams,
  callback: (responseData: any) => void
) {
  fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: data,
  }).then((response) => response.json().then((json) => callback(json)));
}

export function fetchData(url: string, setData: (callback: any) => void) {
  //normal getter method
  fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json().then((json) => setData(json)))
    .catch((error) => {
      console.log("fetch failed=" + error);
    });
}

export function deleteData(url: string, setData: (callback: any) => void) {
  //normal getter method
  fetch(url, {
    method: "DELETE",
  }).then((response) => response.json().then((json) => setData(json)));
}

export function uploadImage(
  url: string,
  formData: FormData,
  callback: (isSuccess: boolean, responseData: any) => void
) {
  fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => callback(true, data))
    .catch((error) => console.error(false, error));
}
